'use client'

import { useLoginInfo } from 'app/_hooks'
import { useCallback } from 'react'

export const useBeforeLoginSessionStorage = () => {
  const loginInfo = useLoginInfo()

  const setBeforeLoginPage = useCallback((BeforeLoginPathname?: string) => {
    const pathname = BeforeLoginPathname ?? window.location.pathname;
    if (loginInfo.status === 'notSignedIn') {
      sessionStorage.setItem('before-login-page', pathname);
    }
  }, [loginInfo])

  const pushRedirectToBeforeLoginPage = useCallback(() => {
    const beforeLoginPage = sessionStorage.getItem('before-login-page')
    if (!beforeLoginPage) return (window.location.href = '/')

    window.location.href = beforeLoginPage
  }, [])

  return { setBeforeLoginPage, pushRedirectToBeforeLoginPage }
}
